import {useEffect, useState} from 'react';
import {Answer} from "features/model/types/test/getTestIdShema";
import {useAppSelector} from "common/hook/UseSelector";
import {useAppDispatch} from "common/hook/UseDispatch";

interface AnswerCorrectnessResult {
    isAnswerCorrect: boolean;
}

export const useAnswerCorrectness = (
    answers: Answer[],
    testItemId: number
): AnswerCorrectnessResult => {
    const resultData = useAppSelector((state) => state.testViewAnswerId.serverData?.data?.result);
    const [answerCorrectness, setAnswerCorrectness] = useState<AnswerCorrectnessResult>({
        isAnswerCorrect: false,
    });

    useEffect(() => {
        const hasStudentAnswer = resultData?.answers?.some((el) => el.questionId === testItemId);

        if (hasStudentAnswer) {
            const hasCorrectAnswer = answers.some((answer) => {
                const isTeacherAnswerCorrect = answer.isCorrect;
                const studentAnswer = resultData?.answers?.find(
                    (el) => el.questionId === testItemId && el.answerId === answer.id
                );
                return isTeacherAnswerCorrect === !!studentAnswer;
            });

            setAnswerCorrectness({
                isAnswerCorrect: hasCorrectAnswer,
            });
        } else {
            setAnswerCorrectness({
                isAnswerCorrect: false,
            });
        }
    }, [answers, testItemId, resultData]);

    return answerCorrectness;
};
